import APIClient from '../request'

import adminAuth from './admin/auth'

import auth from './auth'
import accounts from './accounts'
import shops from './shops'
import groups from './groups'

import reports from './crm/reports'
import salesBudgets from './crm/salesBudgets'
import timeSettings from './crm/timeSettings'
import holidays from './crm/holidays'
import categories from './crm/categories'
import departments from './crm/departments'
import settings from './crm/settings'

function subAPIs (cli) {
  cli.admin = {}
  cli.admin.auth = adminAuth(cli)

  cli.auth = auth(cli)
  cli.accounts = accounts(cli)
  cli.shops = shops(cli)
  cli.groups = groups(cli)

  cli.reports = reports(cli)
  cli.salesBudgets = salesBudgets(cli)
  cli.timeSettings = timeSettings(cli)
  cli.holidays = holidays(cli)
  cli.categories = categories(cli)
  cli.departments = departments(cli)
  cli.settings = settings(cli)
}

const client = new APIClient(process.env.API_ENDPOINT, subAPIs)

client.install = function (Vue) {
  Object.defineProperty(Vue.prototype, '$request', {
    get () {
      return client
    },
  })
}

export default client



// WEBPACK FOOTER //
// ./src/api/index.js